export default () => ({
  requests: [],
  accessTypes: {
    READ: 1,
    WRITE: 2,
    ADMIN: 3
  },
  infoTypes: {
    REQUESTS: 100,
    CANCELED_REQUESTS: 200,
    HISTORY_REQUESTS: 300,
    RATED_REQUESTS: 400,
    ONLINE_USERS: 500,
    WAITING_ROOM_ADMIN: 900
  },
  metrics: {
    averageWaitingTime: 0,
    averageCallDuration: 0,
    ongoingCalls: 0
  },
  requestCancelationReasons: {
    REQUESTED_BY_MISTAKE: {
      id: 1,
      name: 'Requested by mistake'
    },
    CERUMEN: {
      id: 2,
      name: 'Cerumen'
    },
    HIGH_ESTIMATED_WAITING_TIME: {
      id: 3,
      name: 'High estimated waiting time'
    },
    NO_INTERNET_CONNECTION: {
      id: 4,
      name: 'No internet connection'
    },
    OTHER_TECHNICAL_DIFFICULTIES: {
      id: 5,
      name: 'Other technical difficulties'
    },
    CLIENT_GAVE_UP: {
      id: 6,
      name: 'Client gave up'
    },
    RGPD_NOT_SIGNED: {
      id: 7,
      name: 'RGPD Not Signed'
    }
  },
  onlineAudiologists: [],
  pendingRequest: null,
  activeRequest: null,
  activeBreak: null,
  minimizedCallCollapsed: false,
  isLoading: false,
  priorities: {
    1: {
      name: 'low',
      color: '#29c4aa',
      iconClass: 'fa fa-angle-down',
    },
    2: {
      name: 'normal',
      color: '#c49d29',
      iconClass: 'fa fa-minus',
    },
    3: {
      name: 'high',
      color: '#c42940',
      iconClass: 'fa fa-angle-up',
    }
  },
  appointmentTypes: [
    {
      id: 1,
      bdIds: [1,2,45, 80, 8],
      type: 'Teste',
      rowClass: 'appointment-type-row--teste',
      rowColor: '#d6eaf8'
    },
    {
      id: 2,
      bdIds: [3, 115],
      type: 'Fitting',
      rowClass: 'appointment-type-row--fitting',
      rowColor: '#d5f5e3'
    },
    {
      id: 3,
      bdIds: [4],
      type: 'Follow up',
      rowClass: 'appointment-type-row--follow-up',
      rowColor: '#fdebd0'
    },
    {
      id: 5,
      bdIds: [112],
      type: 'Follow up Trial',
      rowClass: 'appointment-type-row--follow-up-trial',
      rowColor: '#ebdef0'
    }
  ]
})
